import { Form as BootstrapForm } from "react-bootstrap";
import Container from "react-bootstrap/Container";

import FormControl from "./FormControl";
import ColorPicker from "./ColorPicker";
import Select from "./Select";

const FormField = ({
  field,
  form: {
    formState: { errors },
    register,
    setValue,
    getValues,
    watch,
    trigger
  },
}) => {
  const getField = (field) => {
    switch (field.type) {
      case "select": {
        return (
          <BootstrapForm.Select
            {...register(field.name)}
            isInvalid={field.name in errors}
            placeholder={field?.placeholder}
          >
            {field.options.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </BootstrapForm.Select>
        );
      }
      case "select-text-input": {
        return (
          <Select
            field={field}
            trigger={trigger}
            setValue={setValue}
            getValues={getValues}
            errors={errors}
          />
        );
      }
      case "color-picker": {
        return <ColorPicker field={field} setValue={setValue} watch={watch} />;
      }
      case "checkbox":
      case "radio":
        return (
          <BootstrapForm.Check
            type={field.type}
            {...register(field.name)}
            defaultValue={1}
            isInvalid={field.name in errors}
            placeholder={field?.placeholder}
            label={field?.label}
          />
        );
      default:
        return (
          <FormControl field={field} errors={errors} register={register} />
        );
    }
  };

  return (
    field && (
      <Container className="text-start">
        {field.type !== "checkbox" && (
          <BootstrapForm.Label style={{ fontSize: "16px" }}>
            {field?.label}
            <span style={{ paddingLeft: '5px' }}>{field?.tooltip}</span>
          </BootstrapForm.Label>
        )}
        {getField(field)}
        {field.name in errors && (
          <p className="text-danger">{errors[field.name].message}</p>
        )}
        {field?.helpText && (
          <BootstrapForm.Text className="text-muted">
            {field.helpText}
          </BootstrapForm.Text>
        )}
      </Container>
    )
  );
};

export default FormField;
